interface ArticleContentProps {
  content: string;
  tags: string[];
  shares: string;
  comments: string;
}

export default function ArticleContent({
  content,
  tags,
}: ArticleContentProps) {
  return (
    <article className="py-12 md:py-16 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="prose-custom">
          {content.split("\n\n").map((paragraph, idx) => (
            <p
              key={idx}
              className="text-base leading-relaxed text-foreground-300 mb-5"
            >
              {paragraph}
            </p>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-300/50">
          <div className="flex flex-wrap items-center gap-2.5">
            {tags.map((tag) => (
              <span
                key={tag}
                className="whitespace-nowrap px-3 py-1.5 text-xs font-medium bg-background-100 text-accent-400 rounded-full border border-background-300/50"
              >
                #{tag}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-8 flex items-center justify-between bg-background-100 rounded-xl px-5 py-4">
          <span className="text-sm text-foreground-500">
            如果这篇爆料对你有帮助，请分享给更多人看到！
          </span>
          <div className="flex items-center gap-3">
            <button
              className="w-9 h-9 rounded-full bg-background-200/70 border border-background-300/50 flex items-center justify-center text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
              aria-label="分享到微博"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-weibo-line"></i>
              </span>
            </button>
            <button
              className="w-9 h-9 rounded-full bg-background-200/70 border border-background-300/50 flex items-center justify-center text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
              aria-label="分享到微信"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-wechat-line"></i>
              </span>
            </button>
            <button
              className="w-9 h-9 rounded-full bg-background-200/70 border border-background-300/50 flex items-center justify-center text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
              aria-label="复制链接"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-link"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </article>
  );
}